import styled, { css } from 'styled-components';
import { StyledText } from "../../CustomAntdComponents/Typography";
import { GREY_6, PRIMARY } from "../../../utils/colors";
import { SwitcherWrapper } from "../styles";

export const ItemWrapper = styled.div<{ active: boolean }>`
  ${({ active }) => active && css`
    padding-bottom: 20px;
    width:100%;
  `}
`;


export const AddItem = styled(StyledText)`
  cursor: pointer;
  color: #000;
  font-size: 16px;
  background: #FAFAFA;
  border: 1px solid #E5E5E5;
  border-radius: 16px;
  diplay: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
`;

export const MultiCityFormWrapper = styled.div`
  ${SwitcherWrapper} {
    @media (max-width: 991px) {
      bottom: -16px;
    }
  }
`;

export const MultiCitySearchOverlay = styled.div`
  // position: fixed;
  inset: 0;
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const Backdrop = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(8, 4, 3, 0.18);
`;

export const Panel = styled.div`
  position: relative;
  // width: min(1120px, calc(60vw - 40px));
  // max-height: calc(100vh - 40px);
  // overflow-y: auto;
  padding: 28px 28px 40px;
  border-radius: 34px;
  background: #ffffff;
  // box-shadow: 0 24px 70px rgba(0, 0, 0, 0.12);
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 28px;
`;

export const BackButton = styled.button`
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: #2c2c2c;
  font-size: 22px;
  cursor: pointer;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 27px;
  font-weight: 700;
  color: #171717;
`;

export const SelectorRow = styled.div`
  max-width: 460px;
  margin-bottom: 28px;
`;

export const RouteList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 24px;
`;

export const RouteRow = styled.div`
  width: 100%;
`;

export const RouteFields = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px 48px;
  gap: 18px;
  align-items: center;

  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
  }
`;

export const FieldGroup = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 42px minmax(0, 1fr);
  gap: 0;
  align-items: center;
`;

export const FieldSlot = styled.div`
  min-width: 0;
`;

export const SwapButton = styled.button`
  width: 42px;
  height: 42px;
  margin: 0 -10px;
  border-radius: 50%;
  border: 1px solid ${GREY_6};
  background: #f6f6f6;
  color: #7a7a7a;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1;
`;

export const DateField = styled.div`
  min-width: 0;
`;

export const RemoveButton = styled.button`
  width: 44px;
  height: 44px;
  border: none;
  background: transparent;
  color: #434455;
  font-size: 24px;
  cursor: pointer;
`;

export const RemoveSpacer = styled.div`
  width: 44px;
  height: 44px;
`;

export const AddButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-width: 280px;
  height: 62px;
  padding: 0 24px;
  border-radius: 24px;
  border: 1px solid ${GREY_6};
  background: #ffffff;
  color: #161616;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const AddIconCircle = styled.span`
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #1f1f1f;
  font-size: 14px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 18px;
  margin-top: 92px;

  @media (max-width: 760px) {
    flex-wrap: wrap;
  }
`;

export const ActionButton = styled.button`
  // min-width: 168px;
  // height: 86px;
  border-radius: 28px;
  border: none;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  padding: 14px 24px;
`;

export const CancelButton = styled(ActionButton)`
  background: #f2f2f2;
  color: #1f1f1f;
`;

export const SearchButton = styled(ActionButton)`
  background: #eca23f;
  color: #ffffff;

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;


export const FooterActions = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  // border-top: 1px solid #eef0f3;
  padding-top: 20px;
`;

// export const ActionButton = styled.button`
//   border: none;
//   border-radius: 999px;
//   padding: 12px 24px;
//   font-size: 16px;
//   font-weight: 600;
//   transition: background-color 0.2s ease;
// `;


export const ApplyButton = styled(ActionButton)`
  background: #e6a23c;
  color: #ffffff;

  &:hover {
    background: #d79430;
  }

  &:disabled {
    cursor: not-allowed;
    background: #f3d7a7;
  }
`;

